<template>
  <div class="box" :class="margin_top">
    <div class="text" :class="[textShort]">{{ text }}：</div>
    <input v-if="showInput" class="input" :type="type" :placeholder="placeholder" v-model="inputValue" @input="getValue"
      @focus="focusInput" />
    <div v-if="!showInput" class="input value">{{ value }}</div>

    <teleport to="body">
      <div class="float-input-box" :class="[show_float_input, extend_input]" :style="float_input_height">
        <input :type="type" class="float-input" :id="rand_id" v-model="inputValue" :placeholder="placeholder">
        <ion-button class="float-button" @click="hideFloatInput">確定</ion-button>
      </div>

      <div class="full-screen" :class="show_translucence">

      </div>
    </teleport>

  </div>
</template>

<script>
import { IonButton } from "@ionic/vue";
import common from "@/common";

export default {
  name: "InputBox",
  components: {
    IonButton
  },
  props: {
    text: { type: String },
    placeholder: { type: String },
    value: { type: String },
    hideInput: { type: String },
    textWidth: { type: String, default: 'long' },
    type: { type: String, default: 'text' },
    margin_top: { type: String, default: 'high' },
    extend_input: { type: String, default: '' },
  },
  data() {
    return {
      showInput: true,
      textShort: '',
      inputValue: '',
      inputElement: {},
      rand_id: '',
      // show_float_input: 'show-float-input',
      show_float_input: 'hide-float-input',
      float_input_height: '',

      focus_input_id: '',
      show_translucence: 'hide-full-screen',
      navigation_height: 0,
    }
  },
  mounted() {
    this.rand_id = 'input_' + Math.round(Math.random() * 1000)

    if (this.hideInput === 'true') {
      this.showInput = false;
    }
    if (this.textWidth === 'short') {
      this.textShort = 'text-short'
    }
    if (this.value) {
      this.inputValue = this.value;
      this.getValue()
    }

    common.getStorage('navigation_height').then(navigation_height => {
      this.navigation_height = navigation_height;
    })

    window.addEventListener('keyboardWillShow', (e) => {
      this.show_float_input = 'hide-float-input';
      this.show_translucence = 'show-full-screen';

      if (this.focus_input_id === this.rand_id) {
        this.float_input_height = 'bottom: ' + (e.keyboardHeight + this.navigation_height) + 'px';
        this.show_float_input = 'show-float-input';
      }


    })

    window.addEventListener('keyboardDidShow', () => {
      if (this.focus_input_id === this.rand_id) {
        document.getElementById(this.focus_input_id).focus();
      }
    })

    window.addEventListener('keyboardWillHide', () => {
      this.show_float_input = 'hide-float-input';
      this.show_translucence = 'hide-full-screen';
      this.getValue();
    })
  },
  methods: {
    getValue: function () {
      this.focus_input_id = '';
      this.$emit('getValue', this.inputValue)
    },
    clearData: function () {
      this.inputValue = '';
    },
    focusInput: function (e) {
      this.inputElement = e.target
      this.focus_input_id = this.rand_id
      // this.show_float_input = 'show-float-input';
    },
    hideFloatInput: function () {
      this.show_float_input = 'hide-float-input';
    },
    autoFillInput: function (value) {
      this.inputValue = value;
      this.getValue();
    }
  }
}
</script>

<style scoped>
.box {
  text-align: center;
  font-size: var(--ecs-font-md);
}

.text {
  display: inline-block;
  width: var(--ecs-label-width);
  text-align: right;
  margin: auto clamp(0.75rem, 2vw, 1.5rem);
}

.input {
  width: var(--ecs-control-width-sm);
  max-width: 90vw;
  box-sizing: border-box;
  min-height: var(--ecs-form-control-min-height);
  padding: var(--ecs-form-control-padding-y) var(--ecs-form-control-padding-x);
  line-height: 1.2;
}

.value {
  display: inline-block;
  text-align: left;
}

.text-short {
  width: clamp(7rem, 14vw, 11rem);
}

.float-input-box {
  width: 100%;
  height: 60px;
  background: white;
  position: absolute;
  z-index: 999;
}

.float-input {
  height: 90%;
  width: 90%;
  border: 2px #94c43b solid;
  font-size: 26px;
  padding-left: 8px;
}

.float-button {
  width: 9%;
  height: 80%;
  margin-bottom: 20px;
  --background: #94c43b;
}

.show-float-input {
  display: block;
}

.hide-float-input {
  display: none;
}

.high {
  margin-top: clamp(1rem, 3vw, 2rem);
}

.short {
  margin-top: clamp(0.5rem, 1vw, 0.75rem);
}

@media (max-width: 640px) {
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .text,
  .text-short {
    box-sizing: border-box;
    width: var(--ecs-control-width-sm);
    max-width: 90vw;
    margin: 0 0 0.25rem;
    text-align: left;
  }
}

.full-screen {
  z-index: 100;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgba(120, 120, 120, 0.5);
}

.hide-full-screen {
  display: none;
}

.show-full-screen {
  display: block;
}
</style>
